"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sum = exports.formatNumberWithSuffix = void 0;
var formatNumberWithSuffix = function (int) {
    if (int > 3 && int < 21) {
        return "".concat(int, "th");
    }
    switch (int % 10) {
        case 1:
            return "".concat(int, "st");
        case 2:
            return "".concat(int, "nd");
        case 3:
            return "".concat(int, "rd");
        default:
            return "".concat(int, "th");
    }
};
exports.formatNumberWithSuffix = formatNumberWithSuffix;
var sum = function (array) { return array.reduce(function (a, b) { return a + b; }, 0); };
exports.sum = sum;
